import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { formatPrice } from '../../utils/numberFormatter';
import { RowItems } from '../../models/TableProps';
import { LiveOrdersData } from '../../models/LiveOrders';

export const LiveOrdersTableRow: React.FC<RowItems<LiveOrdersData>> = (
    props
) => {
    const { row, index, clickHandle, selected } = props;
    const isSelected = (name: string) => selected.indexOf(name) !== -1;
    const isItemSelected = isSelected(row.orderNumber.toString());
    const { t } = useTranslation('liveOrders');
    const labelId = `enhanced-table-checkbox-${index}`;

    return (
        <TableRow
            hover
            role="checkbox"
            aria-checked={isItemSelected}
            tabIndex={-1}
            selected={isItemSelected}
        >
            <TableCell padding="checkbox">
                {/*<Checkbox*/}
                {/*    color="primary"*/}
                {/*    checked={isItemSelected}*/}
                {/*    inputProps={{*/}
                {/*        'aria-labelledby': labelId,*/}
                {/*    }}*/}
                {/*    onClick={(event) =>*/}
                {/*        clickHandle(event, row.invoiceNumber.toString())*/}
                {/*    }*/}
                {/*/>*/}
            </TableCell>
            <TableCell component="th" id={labelId} scope="row" padding="none">
                {row.orderNumber}
            </TableCell>
            <TableCell align="right">{row.date}</TableCell>
            <TableCell align="right">{formatPrice(row.price_net)} Ft</TableCell>
            <TableCell align="right">
                {formatPrice(row.price_gross)} Ft
            </TableCell>
            <TableCell align="right">
                {t(
                    'LIVE_ORDERS.TABLE_CONTENT.STATUS.' +
                        row.status.toString().toUpperCase()
                )}
            </TableCell>
        </TableRow>
    );
};
